import React from 'react';
import styled from 'styled-components';
import colors from 'utils/colors';
import map from 'lodash/map';
import { BorderWrapper } from 'components/styled-components';
import QuestionField from 'components/forms/questionnaire/question-field';

const QuestionCategorySection = ({ questionGroup, ...props }) => (
  <BorderWrapper margin={'1rem'}>
    <CategoryHeader>
      <QuestionTitle>{questionGroup.key}</QuestionTitle>
    </CategoryHeader>
    {map(questionGroup.categorySection, (q, i) => (
      <QuestionField
        step={i + 1}
        question={q}
        answers={q.answers}
        name={q.questionID}
        setFieldValue={props.setFieldValue}
        handleChange={props.handleChange}
        values={props.values}
        key={i}
      />
    ))}
  </BorderWrapper>
);

export default QuestionCategorySection;

const CategoryHeader = styled.div`
  font-weight: 300;
  width: 100%;
  height: 100%;
  border-bottom: 1px solid ${colors.muted};
  background: ${colors.muted};
  color: ${colors.white}
  margin: 0;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

const QuestionTitle = styled.span`
  font-size: 1.5rem;
`;
